var _path, _path2, _g, _path3, _g2, _path4, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSubworkflowShort(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9833_5713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_9833_5713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_9833_5713)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_9833_5713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_9833_5713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint0_linear_9833_5713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint1_radial_9833_5713)"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_9833_5713",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16 0H0V15H16V0Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_9833_5713)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.95233 0.138612L12.7191 2.87516C13.0422 3.04872 13.2446 3.37886 13.2487 3.73907V9.74499C13.2435 10.1049 13.0415 10.4345 12.7191 10.6089L5.12407 14.9646C5.00116 15.0357 4.84257 14.9964 4.76921 14.8767C4.7465 14.8389 4.73375 14.7963 4.73213 14.7525V12.1091L2.12632 10.6089C1.80393 10.4345 1.60184 10.1049 1.59668 9.74499V3.73907C1.60073 3.37886 1.80314 3.04872 2.12632 2.87516L6.89305 0.138612C7.2208 -0.046204 7.62459 -0.046204 7.95233 0.138612Z",
    fill: "url(#paint2_linear_9833_5713)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 3.004C11.481 3.03585 10.9917 3.25636 10.624 3.62401C10.2564 3.99165 10.0358 4.48105 10.004 5H9.996C9.96421 4.48103 9.74371 3.9916 9.37605 3.62395C9.0084 3.25629 8.51897 3.03579 8 3.004V2.996C8.51897 2.96421 9.0084 2.74371 9.37605 2.37605C9.74371 2.0084 9.96421 1.51897 9.996 1H10.004C10.0358 1.51895 10.2564 2.00835 10.624 2.37599C10.9917 2.74364 11.481 2.96415 12 2.996V3.004Z",
    fill: "url(#paint3_radial_9833_5713)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6717 11.1243H13.5606C13.7497 11.1243 13.9199 11.2752 13.9199 11.4827V12.3695C13.9199 12.5582 13.7686 12.728 13.5606 12.728H12.6717C12.4826 12.728 12.3124 12.5771 12.3124 12.3695V12.011H12.1421C11.6504 12.011 11.2533 11.6148 11.2533 11.1243V9.70915H10.3644V11.4827C10.3644 11.6714 10.2131 11.8412 10.005 11.8412H6.27926C6.09013 11.8412 5.91992 11.6903 5.91992 11.4827V7.7469C5.91992 7.55822 6.07122 7.38841 6.27926 7.38841H8.05704V5.8035H6.27926C6.07122 5.8035 5.91992 5.65256 5.91992 5.44501V5.08652C5.91992 4.89784 6.07122 4.72803 6.27926 4.72803H13.5606C13.7497 4.72803 13.9199 4.87897 13.9199 5.08652V5.44501C13.9199 5.63369 13.7686 5.8035 13.5606 5.8035H8.22725V7.40728H10.005C10.1941 7.40728 10.3644 7.55822 10.3644 7.76577V9.52048H11.2533V8.10538C11.2533 7.61482 11.6504 7.2186 12.1421 7.2186H12.3124V6.86011C12.3124 6.67143 12.4637 6.50161 12.6717 6.50161H13.5606C13.7497 6.50161 13.9199 6.65256 13.9199 6.86011V7.7469C13.9199 7.93558 13.7686 8.10538 13.5606 8.10538H12.6717C12.4826 8.10538 12.3124 7.95445 12.3124 7.7469V7.38841H12.1421C11.745 7.38841 11.4235 7.70916 11.4235 8.10538V9.52048H12.3124V9.16198C12.3124 8.9733 12.4637 8.80349 12.6717 8.80349H13.5606C13.7497 8.80349 13.9199 8.95444 13.9199 9.16198V10.0488C13.9199 10.2375 13.7686 10.4073 13.5606 10.4073H12.6717C12.4826 10.4073 12.3124 10.2563 12.3124 10.0488V9.70915H11.4235V11.1243C11.4235 11.5205 11.745 11.8412 12.1421 11.8412H12.3124V11.4827C12.3124 11.2752 12.4826 11.1243 12.6717 11.1243Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_9833_5713",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#645EFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F3BF5D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_9833_5713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_9833_5713",
    x1: 4.69857,
    y1: 2.88773,
    x2: 13.5,
    y2: 12.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#665DFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0E274D"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_9833_5713",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.397 2.62575) rotate(23.8875) scale(3.3937 27.1856)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#A9A2A5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.46,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#B8B8B8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9833_5713"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 15,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSubworkflowShort);
export default __webpack_public_path__ + "static/media/Subworkflow-Short.467adfdc843607f56f23e71bccdd0f12.svg";
export { ForwardRef as ReactComponent };